(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  let queued = false;
  let chat;
  let roots = [];
  const observedRoots = new Set();
  const observer = new ResizeObserver(connect);
  const contentObserver = new MutationObserver(connect);

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }

  function update() {
    queued = false;
    const launcher = roots.map(root => root.querySelector('button.activator')).find(Boolean);
    const openDialog = roots.some(root => [...root.querySelectorAll('[role="dialog"]')].some(dialog => dialog.getClientRects().length && getComputedStyle(dialog).visibility !== 'hidden'));
    if (!mobile.matches || !launcher || openDialog) {
      document.body.classList.remove('lbe-chat-clearance');
      return;
    }
    const box = launcher.getBoundingClientRect();
    if (!box.width || !box.height) return;
    const overlaps = [...document.querySelectorAll('a, button, input, select, textarea, summary, [role="button"], .product-form__input label')]
      .some(control => {
        if (!control.getClientRects().length) return false;
        const style = getComputedStyle(control);
        if (style.visibility === 'hidden' || style.display === 'none') return false;
        const rect = control.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 &&
          rect.top < box.bottom + 8 && rect.bottom > box.top - 8 &&
          rect.left < box.right + 8 && rect.right > box.left - 8;
      });
    document.body.classList.toggle('lbe-chat-clearance', overlaps);
  }

  function connect() {
    const found = document.querySelector('shopify-chat');
    if (found && found !== chat) {
      if (chat) observer.unobserve(chat);
      contentObserver.disconnect();
      observedRoots.clear();
      chat = found;
      observer.observe(chat);
    }
    roots = chat?.shadowRoot ? [chat.shadowRoot] : [];
    for (let index = 0; index < roots.length; index++) {
      const root = roots[index];
      for (const node of root.querySelectorAll('*')) {
        if (node.shadowRoot) roots.push(node.shadowRoot);
      }
      if (!observedRoots.has(root)) {
        contentObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded', 'open'] });
        observedRoots.add(root);
      }
    }
    schedule();
  }

  new MutationObserver(connect).observe(document.body, { childList: true });
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  document.addEventListener('click', schedule, { capture: true });
  document.addEventListener('change', schedule, { capture: true });
  window.addEventListener('resize', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  connect();
})();
